import dayjs from 'dayjs';

type DateRange = {
  from?: string | Date;
  to?: string | Date;
};

export const isDateInRange = (date: string | Date, range?: DateRange): boolean => {
  if (!range?.from && !range?.to) return true;
  
  const targetDate = dayjs(date).startOf('day');
  const fromDate = range.from && dayjs(range.from).startOf('day');
  const toDate = range.to && dayjs(range.to).startOf('day');
  
  if (fromDate && targetDate.isBefore(fromDate)) return false;
  if (toDate && targetDate.isAfter(toDate)) return false;
  
  return true;
}; 


export const compareDateDesc = <T extends Record<string, any>, K extends keyof T>(key: K) => {
  return (a: T, b: T) => dayjs(b[key]).unix() - dayjs(a[key]).unix();
};

export const compareDateAsc = <T extends Record<string, any>, K extends keyof T>(key: K) => {
  return (a: T, b: T) => dayjs(a[key]).unix() - dayjs(b[key]).unix();
};


type DataWithDate = { date: number };

export const fillMissingDays = <T extends DataWithDate>(
  data: T[],
  startDate: Date,
  endDate: Date
): T[] => {
  const filledData: T[] = [];
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  for (
    let d = start;
    d.isBefore(end) || d.isSame(end);
    d = d.add(1, 'day')
  ) {
    const existingData = data.find((item) =>
      dayjs.unix(item?.date).isSame(d, 'day')
    );
    if (existingData) {
      filledData.push(existingData);
    } else {
      filledData.push({
        ...({ date: d.unix() } as unknown as T),
      });
    }
  }

  return filledData;
};